module.exports = __webpack_public_path__ + "img/10.c23d49c2.jpg";